import { TextFieldProps } from '@material-ui/core/TextField';
import React from 'react';

import { BaseTextField } from './BaseTextField';
// src/components/textfield/NumberTextField.tsx

/**
 * @description This is deprecated. Please use the new NumberTextField component in src/components/textfield/NumberTextField.tsx
 * @deprecated use the new component in src/components/textfield/NumberTextField.tsxtsx
 * @returns
 */
export const NumberTextField: React.FC<TextFieldProps> = ({
  onChange,
  ...textFieldProps
}) => {
  const handleChange = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
  ) => {
    if (onChange && event.target.value.match(/^\d*\.?\d*$/)) {
      onChange(event);
    }
  };

  return <BaseTextField onChange={handleChange} {...textFieldProps} />;
};
